export default function(s){
    return s.replace(/<(.*?)>/, '-').toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '')
}